import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import ReelCard from "./ReelCard";

const SLIDE_DURATION = 4000; // 4 seconds per image
const TICK = 100;

const REELS = [
  {
    id: 1,
    image: "/images/landing-s1-img.png",
  },
  {
    id: 2,
    image: "/images/img_rectangle17564_3.png",
  },
  {
    id: 3,
    image: "/images/product-4.png",
  },
];

const ReelStorySlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          setActiveIndex((i) => (i + 1) % REELS.length);
          return 0;
        }
        return prev + 100 / (SLIDE_DURATION / TICK);
      });
    }, TICK);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        width: 320,
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <ReelCard image={REELS[activeIndex].image} />
       <Box sx={{ display: "flex", gap: 0.5 }}>
        {REELS.map((_, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              height: 4,
              backgroundColor: "rgba(255,255,255,0.4)",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                height: "100%",
                width:
                  index < activeIndex
                    ? "100%"
                    : index === activeIndex
                    ? `${progress}%`
                    : "0%",
                backgroundColor: "#771237",
                transition:
                  index === activeIndex ? "width 0.1s linear" : "none",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ReelStorySlider;
